module.exports = __webpack_public_path__ + "static/media/Add_Logo_Icon.0debf41c.svg";